// DS: i6.26
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const MultiImage: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path d="M1 13.446c0 .542.38.989.87 1.047a.9.9 0 00.098.007H8.14c.438 0 .793-.382.793-.853a.897.897 0 00-.124-.459.781.781 0 00-.669-.395H2.587v-5.17a.869.869 0 00-.374-.723.75.75 0 00-.42-.13c-.438 0-.793.382-.793.854v5.822z"></path>
        <path d="M4.015 11.093a1.1 1.1 0 01-.215-.659V4.612c0-.471.355-.853.793-.853a.75.75 0 01.42.129c.225.15.374.419.374.724v5.17h5.553c.3 0 .562.18.697.445a.9.9 0 01.096.408c0 .471-.355.853-.793.853H4.78a.932.932 0 01-.103-.005l-.007-.001a.94.94 0 01-.497-.22 1.024 1.024 0 01-.158-.169z"></path>
        <path
          fillRule="evenodd"
          d="M6.704 8.082a.774.774 0 01-.104-.388V2.333c0-.46.407-.833.91-.833h6.58c.503 0 .91.373.91.833v5.361c0 .46-.407.833-.91.833H7.51c-.201 0-.386-.06-.537-.16a.863.863 0 01-.269-.285zm6.71-4.882v3.627H8.186V3.2h5.226z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
MultiImage.displayName = 'MultiImage';

export default MultiImage;
